import { useCart } from '../../context/CartContext';
import { formatPrice } from '../../utils/helpers';
import './OrderSummary.css';

const OrderSummary = ({ shippingInfo, quote }) => {
  const { cart } = useCart();

  const subtotal =
    cart?.items?.reduce((sum, item) => {
      const price = parseFloat(item.product?.price || 0);
      return sum + price * item.quantity;
    }, 0) || 0;

  const shippingCost = quote?.shipping_cost ?? 0;
  const codSurcharge = quote?.cod_surcharge ?? 0;
  const total = subtotal + parseFloat(shippingCost) + parseFloat(codSurcharge);

  return (
    <div className="order-summary">
      <h3>Order Summary</h3>

      {shippingInfo && (
        <div className="order-summary-section">
          <h4>Shipping To:</h4>
          <p>{shippingInfo.fullName}</p>
          <p>{shippingInfo.address}</p>
          <p>
            {[shippingInfo.city, shippingInfo.districtName, shippingInfo.provinceName]
              .filter(Boolean)
              .join(', ')}
          </p>
          <p>{shippingInfo.phone}</p>
        </div>
      )}

      <div className="order-summary-section">
        <h4>Items:</h4>
        <div className="order-items">
          {cart?.items?.map(item => (
            <div key={item.id} className="order-item">
              <span>
                {item.product.name}
                {item.color && (
                  <>
                    {' '}
                    <span
                      className="order-item-color-swatch"
                      style={{ backgroundColor: item.color.hex_code }}
                      aria-hidden="true"
                    />
                    <span className="order-item-color-name">{item.color.name}</span>
                  </>
                )}
                {' '}× {item.quantity}
              </span>
              <span>
                {formatPrice(parseFloat(item.product?.price || 0) * item.quantity)}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="order-summary-totals">
        <div className="order-summary-row">
          <span>Subtotal:</span>
          <span>{formatPrice(subtotal)}</span>
        </div>
        <div className="order-summary-row">
          <span>
            Shipping{quote?.zone?.name ? ` (${quote.zone.name})` : ''}:
          </span>
          <span>
            {quote?.free_shipping_applied ? (
              <span className="order-free">FREE</span>
            ) : (
              formatPrice(shippingCost)
            )}
          </span>
        </div>
        {parseFloat(codSurcharge) > 0 && (
          <div className="order-summary-row">
            <span>Cash-on-Delivery fee:</span>
            <span>{formatPrice(codSurcharge)}</span>
          </div>
        )}
        <div className="order-summary-row order-summary-total">
          <span>Total:</span>
          <span>{formatPrice(total)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;
